// Shared free-tier gate copy (expansion date window, signal blur, API keys).
export default {
  premium: {
    tag: "會員",
    gate: {
      signalsTitle: "最新的 {n} 條訊號已鎖定",
      signalsDesc: "升級即可查看每家公司自始至今的全部擴張訊號。",
      signalsCta: "解鎖訊號",
    },
    dateWindow: {
      tip: "免費版僅支援最近 {n} 天。升級可查看完整歷史。",
      lockedLabel: "升級以查看完整歷史",
    },
    apiKeys: {
      bannerTitle: "API 存取為付費功能",
      bannerDesc: "產生金鑰、自動匯出，並以程式方式查詢 Pubrio。",
      tip: "升級方案即可建立 API 金鑰。",
      cta: "查看方案",
    },
    team: {
      locked: "查看團隊",
      tip: "升級即可查看該市場的本地團隊。",
    },
    source: {
      locked: "查看來源",
      tip: "升級即可開啟每條訊號背後的來源。",
    },
    employees: {
      locked: "員工資料已鎖定",
      tip: "升級即可查看該公司的人數與相關人員。",
      cta: "解鎖員工",
    },
    markets: {
      moreLocked: "+{n} 個更多市場",
    },
  },
};
